export const ROOT = '/';
export const DASHBOARD = '/dashboard';
export const LOGIN = '/login';
export const PROFILE = '/p/:username';

export const Trending = '/trending';
export const Genres = '/genres';
export const Search = '/search-movie-tv';

// Movies
export const Movies_Discover = '/discover-movies';
export const Movies_In_Theatre = '/in-theatre-movies';
export const Movies_Popular = '/popular-movies';
export const Movies_Top_Rated = '/top-rated-movies';
export const Movies_Upcoming = '/upcoming-movies';

//contact
export const Contact='/Contact';


// Movies
export const Series_Discover = '/discover-series';
export const Series_Popular = '/popular-series';
export const Series_Top_Rated = '/top-rated-series';
export const Series_Upcoming = '/upcoming-series';

// Credits
export const Person_Detail = '/person/:id';
export const Popular_Persons = '/popular-persons';
export const Perosn_Search = '/search-credit';


export const Chats = '/chats';
// export const Chats = '/ChatPage';

export const Details = '/:type/:id';
export const Genre_Detail = '/genre/:type/:name/:gid';

export const NOT_FOUND = '/not-found';
